<template>
  <div class="tooltip-body">
    <span class="tooltip-title block mb-3 font-bold">
      <zt-icon name="info-circle-alt" />
      {{
        $t('message.loginComponent.passwordExpired.password_policies.title')
      }}</span>
    <ul class="list-disc ml-4">
      <li class="mb-2" v-for="(policie, index) in policies" :key="index">
        {{ policie }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    passPolicies: {
      type: [Object, Array],
      default: []
    }
  },
  data() {
    return {
      policies: [],
      updatekey: 0
    }
  },
  watch: {
    passPolicies() {
      this.parsePolicies()
    }
  },
  created() {
    this.parsePolicies()
  },
  methods: {
    parsePolicies() {
      let tmpArr = []
      if (Object.entries(this.passPolicies).length > 0) {
        if (this.passPolicies.minimalongitud) {
          tmpArr.push(this.textMinCharacter())
        }
        if (this.passPolicies.maximalongitud) {
          tmpArr.push(this.textMaxCharacter())
        }
        if (this.passPolicies.minimalongitudletras) {
          tmpArr.push(this.textMinLettersCharacter())
        }
        if (
          this.passPolicies.historialsinrepetir &&
          this.passPolicies.historialsinrepetir > 0
        ) {
          tmpArr.push(this.textHistoryPass())
        }
        if (this.passPolicies.caducidad) {
          tmpArr.push(this.textExpirePass())
        }
        if (
          this.passPolicies.minimacantidadcaracteresespeciales &&
          parseInt(this.passPolicies.minimacantidadcaracteresespeciales, 10) > 0
        ) {
          tmpArr.push(this.textSpecialCharacters())
        }
        if (
          this.passPolicies.minimacantidadmayusculas &&
          parseInt(this.passPolicies.minimacantidadmayusculas, 10) > 0
        ) {
          tmpArr.push(this.textMinCapitalLetter())
        }
        if (
          this.passPolicies.minimacantidaddigitos &&
          parseInt(this.passPolicies.minimacantidaddigitos, 10) > 0
        ) {
          tmpArr.push(this.textMinNumber())
        }

        tmpArr.push(
          this.$t('message.loginComponent.firstLogin.notPersonalInfo')
        )
        tmpArr.push(this.$t('message.loginComponent.firstLogin.notEasyPassw'))
      }

      this.policies = tmpArr
    },
    textHistoryPass() {
      let amount = this.passPolicies.historialsinrepetir
      let txt = this.$t('message.loginComponent.passwordExpired.password_policies.history_pass', { input: amount });
      return txt
    },
    textExpirePass() {
      let amount = this.passPolicies.caducidad
      let txt = this.$t(
        'message.loginComponent.passwordExpired.password_policies.no_expire'
      )
      if (amount !== -1) {
        txt = this.$t('message.loginComponent.passwordExpired.password_policies.expire', { input: amount });
      }

      return txt
    },
    textSpecialCharacters() {
      let amount = this.passPolicies.minimacantidadcaracteresespeciales
      let txt = this.$t('message.loginComponent.passwordExpired.password_policies.special_characters_amount', { input: amount });

      if (amount === '1') {
        txt = txt.replace(this.$t("message.inicioComponent.caracteres"), this.$t("message.inicioComponent.caracter"))
      }

      return `${txt} (${this.passPolicies.caracterespespeciales.join()})`
    },
    textMaxCharacter() {
      let amount = this.passPolicies.maximalongitud
      let txt = this.$t('message.loginComponent.passwordExpired.password_policies.max_character', { input: amount });
      return txt
    },
    textMinCharacter() {
      let amount = this.passPolicies.minimalongitud
      let txt = this.$t('message.loginComponent.passwordExpired.password_policies.min_character', { input: amount });
      return txt
    },
    textMinLettersCharacter() {
      let amount = this.passPolicies.minimalongitudletras
      let txt = this.$t('message.loginComponent.passwordExpired.password_policies.min_letter', { input: amount });
      return txt
    },
    textMinNumber() {
      let amount = this.passPolicies.minimacantidaddigitos
      let txt = this.$t('message.loginComponent.passwordExpired.password_policies.min_numbers', { input: amount });

      if (parseInt(amount, 10) > 1) {
        txt = txt.replace(this.$t('message.inicioComponent.number'), this.$t('message.inicioComponent.numbers'))
      }

      return txt
    },
    textMinCapitalLetter() {
      let amount = this.passPolicies.minimacantidadmayusculas
      let txt = this.$t('message.loginComponent.passwordExpired.password_policies.min_capital_letter', { input: amount });

      if (parseInt(amount, 10) > 1) {
        txt = txt.replace(this.$t('message.inicioComponent.upperCase'), this.$t('message.inicioComponent.upperCases'))
      }

      return txt
    }
  }
}
</script>

<style scoped lang="scss">
.tooltip-body {
  color: #575757;

  .tooltip-title {
    color: #03a9f4;
  }
}
</style>